<template>
  <BaseSentimentPieChart
    :title="title"
    :item-id="itemId"
    :owner-posts="true"
    v-bind="$attrs"
  />
</template>

<script>
import BaseSentimentPieChart from '@/components/cards/BaseSentimentPieChart';
import proprietaryModel from '@/mixins/proprietary-model';

export default {
  name: 'PropSentimentPie',
  components: {
    BaseSentimentPieChart,
  },
  mixins: [
    proprietaryModel,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
  },
};
</script>
